/**
 * TOOJ PDP info — size radio selector, ATC label, tabs
 */
(function () {
  if (!document.body.classList.contains('hdt-page-type-product')) return;

  var SELECT_LABEL = 'SELECT A SIZE';
  var CART_LABEL = 'ADD TO CART';

  function rootEl() {
    return document.querySelector('.tooj-pdp-info');
  }

  function sizeSection() {
    var root = rootEl();
    return root ? root.querySelector('[data-tooj-size-section]') : null;
  }

  function getAtcTextEls() {
    var root = rootEl();
    if (!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll('.hdt-product-form__submit .hdt-btn-atc_text'));
  }

  function setAtcLabel(text) {
    getAtcTextEls().forEach(function (el) {
      el.textContent = text;
    });
  }

  function setAtcDisabled(disabled) {
    var root = rootEl();
    if (!root) return;
    root.querySelectorAll('.hdt-product-form__submit').forEach(function (btn) {
      btn.disabled = !!disabled;
      if (disabled) btn.setAttribute('disabled', 'disabled');
      else btn.removeAttribute('disabled');
    });
  }

  function getProductForm() {
    var root = rootEl();
    if (!root) return null;
    return root.querySelector('form[action*="/cart/add"], form[id^="product-form-"]');
  }

  function getVariantIdInput() {
    var form = getProductForm();
    return form ? form.querySelector('input[name="id"]') : null;
  }

  function setSelectedVariantId(variantId) {
    if (!variantId) return;
    var idInput = getVariantIdInput();
    if (!idInput) return;
    idInput.disabled = false;
    idInput.removeAttribute('disabled');
    idInput.value = String(variantId);
  }

  function markSelectedLabel(input) {
    var section = sizeSection();
    if (!section || !input) return;

    section.querySelectorAll('.tooj-pdp-kith__size-btn, .size-option-btn').forEach(function (label) {
      label.classList.remove('is-selected', 'active');
      label.setAttribute('aria-pressed', 'false');
    });

    var label = section.querySelector('label[for="' + input.id + '"]');
    if (!label && input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL') {
      label = input.nextElementSibling;
    }
    if (label) {
      label.classList.add('is-selected', 'active');
      label.setAttribute('aria-pressed', 'true');
    }
  }

  function onSizeChosen(input) {
    if (!input || input.classList.contains('is-disabled') || input.classList.contains('is-unavailable')) return;

    markSelectedLabel(input);
    setSelectedVariantId(input.getAttribute('data-variant-id') || input.value);
    setAtcLabel(CART_LABEL);
    setAtcDisabled(false);
  }

  function initSizeSelector() {
    var section = sizeSection();
    if (!section || section.getAttribute('data-tooj-size-ready') === 'true') return;
    section.setAttribute('data-tooj-size-ready', 'true');

    var inputs = section.querySelectorAll('.tooj-pdp-size-input, input[type="radio"][data-size-value], input[type="radio"][is-value]');
    if (!inputs.length) return;

    // Start unselected for Kith UX
    var checked = section.querySelector('input[type="radio"]:checked');
    if (checked) {
      onSizeChosen(checked);
    } else {
      setAtcLabel(SELECT_LABEL);
      setAtcDisabled(true);
    }

    section.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.type !== 'radio') return;
      if (!section.contains(input)) return;
      onSizeChosen(input);
    });

    // Label clicks (extra safety for theme event conflicts)
    section.addEventListener('click', function (e) {
      var label = e.target.closest('label.tooj-pdp-kith__size-btn, label.size-option-btn, label[data-size-option]');
      if (!label || !section.contains(label)) return;
      if (label.classList.contains('is-disabled')) {
        e.preventDefault();
        return;
      }

      var input = label.htmlFor ? document.getElementById(label.htmlFor) : null;
      if (!input) return;

      // Force native radio selection even if theme stops default
      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        onSizeChosen(input);
      }
    });
  }

  function activateTab(tabName) {
    var root = document.querySelector('[data-tooj-pdp-tabs]');
    if (!root) return;

    root.querySelectorAll('.tooj-pdp-kith__tab-btn').forEach(function (btn) {
      var isActive = btn.getAttribute('data-tab') === tabName;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    root.querySelectorAll('.tooj-pdp-kith__tab-panel').forEach(function (panel) {
      var isActive = panel.getAttribute('data-panel') === tabName;
      panel.classList.toggle('is-active', isActive);
      if (isActive) panel.removeAttribute('hidden');
      else panel.setAttribute('hidden', '');
    });
  }

  function initTabs() {
    var tabs = document.querySelector('[data-tooj-pdp-tabs]');
    if (!tabs || tabs.getAttribute('data-tooj-tabs-bound') === 'true') return;
    tabs.setAttribute('data-tooj-tabs-bound', 'true');

    tabs.querySelectorAll('.tooj-pdp-kith__tab-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        activateTab(btn.getAttribute('data-tab'));
      });
    });
  }

  function initSizeGuideTab() {
    /* Size chart opens via modal in tooj-size-chart.js */
  }

  function initProductFormGuard() {
    var form = getProductForm();
    if (!form || form.getAttribute('data-tooj-form-guard') === 'true') return;
    form.setAttribute('data-tooj-form-guard', 'true');

    form.addEventListener('submit', function (event) {
      var section = sizeSection();
      var selected = section ? section.querySelector('input[type="radio"]:checked') : null;
      if (!selected) {
        event.preventDefault();
        setAtcLabel(SELECT_LABEL);
        setAtcDisabled(true);
        return;
      }
      var idInput = getVariantIdInput();
      if (idInput) {
        idInput.disabled = false;
        idInput.removeAttribute('disabled');
        var vid = selected.getAttribute('data-variant-id');
        if (vid) idInput.value = vid;
      }
    });
  }

  function init() {
    if (!rootEl()) return;
    initSizeSelector();
    initTabs();
    initSizeGuideTab();
    initProductFormGuard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    var section = sizeSection();
    if (section) section.removeAttribute('data-tooj-size-ready');
    init();
  });
})();
